module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "panel power-bar-panel",
    style: ({
      '--height': _vm.maxLineHeight
    }),
    attrs: {
      "id": ("power-bar-panel" + _vm.blockIndex)
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "power-bar-line-bg",
    attrs: {
      "id": ("power-bar-line-bg" + _vm.blockIndex)
    }
  }), _c('div', {
    ref: "powerBarLine",
    staticClass: "power-bar-line",
    attrs: {
      "id": ("power-bar-line" + _vm.blockIndex)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.paragraph))]), _c('div', {
    staticClass: "power-bar-precentage-year"
  }, [_c('div', {
    staticClass: "power-bar-precentage"
  }, [_c('div', {
    staticClass: "power-bar-precentage-text"
  }, [_vm._v(_vm._s(_vm.firstRowText))]), _c('div', {
    staticClass: "power-bar-precentage-value"
  }, [_vm._v(_vm._s(_vm.getPowerBarPrecentage()))])]), _c('div', {
    staticClass: "power-bar-year"
  }, [_c('div', {
    staticClass: "power-bar-year-text"
  }, [_vm._v(_vm._s(_vm.secondRowText))]), _c('div', {
    staticClass: "power-bar-year-value"
  }, [_vm._v(_vm._s(_vm.getPowerBarYear()))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cdb8e0f0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CMSPowerBar.vue
// module id = 290
// module chunks = 15